import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginPage } from '@/features/auth/login-page';
import { meQuery } from '@/lib/auth/session';

/** Only paths of this site: never an absolute or protocol-relative URL. */
export const safeRedirect = (value: string | undefined): string =>
  value?.startsWith('/') &&
  !value.startsWith('//') &&
  !value.startsWith('/login') &&
  !value.startsWith('/password') &&
  !value.startsWith('/totp-setup')
    ? value
    : '/shipments';

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    redirect: z.string().optional(),
    reason: z.enum(['expired']).optional(),
  }),
  beforeLoad: async ({ context, search }) => {
    const user = await context.queryClient.ensureQueryData(meQuery).catch(() => null);
    if (user) throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: Login,
});

function Login() {
  const search = Route.useSearch();
  const router = useRouter();
  return (
    <LoginPage
      reason={search.reason}
      onSignedIn={() => {
        void router.navigate({ href: safeRedirect(search.redirect), replace: true });
      }}
    />
  );
}
